// import { useSelector } from 'react-redux';/
import { useLocation } from "react-router-dom"
import billing from "assets/images/placeholderImgs/billing_ss.jpg"
import insights from "assets/images/placeholderImgs/insights_ss.jpg"
import loadProfile from "assets/images/placeholderImgs/load_profile_ss.jpg"
import { useSelector } from "react-redux"

const usePermission = () => {
  const location = useLocation()
  const permissions = useSelector(state => state?.Profile?.profile?.usermodules)

  const modules = {
    "/billing": { id: 20, img: billing },
    "/insights": { id: 21, img: insights },
    "/load-profile": { id: 22, img: loadProfile },
  }

  const hasPermission = path => {
    if (currentPath === "/billing") {
      return true
    }
    return permissions?.some(
      perm => perm?.moduleid === modules?.[path]?.id && perm?.enabled === 1
    )
  }

  const currentPath = location.pathname

  const permissionGranted = hasPermission(currentPath)

  return { hasPermission: permissionGranted, img: modules?.[currentPath]?.img }
}

export default usePermission
